<template>
  <generic-modal
    :title="$t('identity verification detail')"
    size="fullscreen"
    ref="generic_modal"
  >
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box mb-4">
          <div class="media">
            <div class="media-left">
              <span class="icon is-large has-text-primary">
                <i class="fa fa-user-circle fa-2x"></i>
              </span>
            </div>
            <div class="media-content">
              <div class="title is-4 mb-1">
                {{ meta.first_name }} {{ meta.last_name }}
              </div>
              <div class="subtitle is-6 mb-2">
                <span class="icon"><i class="fa fa-id-card"></i></span>
                <span>{{ meta.id_number }}</span>
              </div>
              <div class="tags">
                <span
                  class="tag is-rounded"
                  :class="{
                    'is-primary': meta.face_image,
                    'is-warning': !meta.face_image,
                  }"
                >
                  <span class="icon">
                    <i
                      class="fa"
                      :class="{
                        'fa-check': meta.face_image,
                        'fa-times': !meta.face_image,
                      }"
                    ></i>
                  </span>
                  <span>{{ $t("face image") }}</span>
                </span>
                <span
                  class="tag is-rounded"
                  :class="{
                    'is-primary': meta.id_front_image,
                    'is-warning': !meta.id_front_image,
                  }"
                >
                  <span class="icon">
                    <i
                      class="fa"
                      :class="{
                        'fa-check': meta.id_front_image,
                        'fa-times': !meta.id_front_image,
                      }"
                    ></i>
                  </span>
                  <span>{{ $t("id front image") }}</span>
                </span>
                <span
                  class="tag is-rounded"
                  :class="{
                    'is-primary': meta.id_back_image,
                    'is-warning': !meta.id_back_image,
                  }"
                >
                  <span class="icon">
                    <i
                      class="fa"
                      :class="{
                        'fa-check': meta.id_back_image,
                        'fa-times': !meta.id_back_image,
                      }"
                    ></i>
                  </span>
                  <span>{{ $t("id back image") }}</span>
                </span>
                <span
                  class="tag is-rounded"
                  :class="{
                    'is-primary': meta.renap_request_id,
                    'is-warning': !meta.renap_request_id,
                  }"
                >
                  <span class="icon">
                    <i
                      class="fa"
                      :class="{
                        'fa-check': meta.renap_request_id,
                        'fa-times': !meta.renap_request_id,
                      }"
                    ></i>
                  </span>
                  <span>{{ $t("renap data") }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-mobile is-multiline">
          <div class="column is-6">
            <div class="card">
              <div class="card-content has-text-centered">
                <div class="title is-6 mb-2">
                  <span class="icon"><i class="fa fa-camera"></i></span>
                  {{ $t("renap photo") }}
                </div>
                <figure class="image is-128x128 m-auto py-2">
                  <img
                    v-if="meta.renap_data && meta.renap_data.FOTO"
                    :src="`data:image/jpeg;base64,${meta.renap_data.FOTO}`"
                    alt="Renap Photo"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                  <img
                    v-else
                    src="@/assets/no-image.jpg"
                    alt="No Renap Photo"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                </figure>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="card">
              <div class="card-content has-text-centered">
                <div class="title is-6 mb-2">
                  <span class="icon"><i class="fa fa-user"></i></span>
                  {{ $t("face image") }}
                </div>
                <figure class="image is-128x128 m-auto py-2">
                  <v-lazy-image
                    v-if="meta.face_image && meta.face_image.file"
                    :src="`${api_host}/drive/static/${meta.face_image.file.settings.final_name}`"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                  <img
                    v-else
                    src="@/assets/no-image.jpg"
                    alt="No Face Image"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="columns is-mobile is-multiline">
          <div class="column is-6">
            <div class="card">
              <div class="card-content has-text-centered">
                <div class="title is-6 mb-2">
                  <span class="icon"><i class="fa fa-id-card"></i></span>
                  {{ $t("id front image") }}
                </div>
                <figure class="image is-128x128 m-auto py-2">
                  <v-lazy-image
                    v-if="meta.id_front_image && meta.id_front_image.file"
                    :src="`${api_host}/drive/static/${meta.id_front_image.file.settings.final_name}`"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                  <img
                    v-else
                    src="@/assets/no-image.jpg"
                    alt="No ID Front Image"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                </figure>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="card">
              <div class="card-content has-text-centered">
                <div class="title is-6 mb-2">
                  <span class="icon"><i class="fa fa-id-card"></i></span>
                  {{ $t("id back image") }}
                </div>
                <figure class="image is-128x128 m-auto py-2">
                  <v-lazy-image
                    v-if="meta.id_back_image && meta.id_back_image.file"
                    :src="`${api_host}/drive/static/${meta.id_back_image.file.settings.final_name}`"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                  <img
                    v-else
                    src="@/assets/no-image.jpg"
                    alt="No ID Back Image"
                    style="border-radius: 8px; border: 1px solid #eee"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Análisis y datos personales -->
    <div class="box mt-4">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="title is-5 mb-3">
            <span class="icon"><i class="fa fa-user-check"></i></span>
            {{ $t("personal data") }}
          </div>
          <table class="table is-bordered is-fullwidth is-size-7">
            <tbody>
              <tr
                v-for="(value, key) in meta.renap_data"
                :key="key"
                v-show="key != 'FOTO'"
              >
                <td>
                  <strong>{{ key }}</strong>
                </td>
                <td>{{ value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="column is-4">
          <div class="notification">
            <div class="mb-2">
              <span class="icon"><i class="fa fa-user"></i></span>
              <strong>{{ $t("selfie analysis") }}</strong>
            </div>
            <template v-if="isJsonAnalysis(meta.face_analysis)">
              <div
                v-for="(result, key) in getFaceAnalysisObj()"
                :key="key"
                class="mb-3"
              >
                <div class="box is-shadowless">
                  <div class="mb-2">
                    <span class="tag is-info">{{ key }}</span>
                    <span
                      class="tag is-pulled-right is-rounded"
                      :class="result.verified ? 'is-success' : 'is-danger'"
                    >
                      <i
                        class="fa"
                        :class="result.verified ? 'fa-check' : 'fa-times'"
                      ></i>
                      {{
                        result.verified ? $t("verified") : $t("not verified")
                      }}
                    </span>
                  </div>
                  <ul class="is-size-7" style="margin-bottom: 0.5em">
                    <li>
                      <strong>{{ $t("model") }}:</strong> {{ result.model }}
                    </li>
                    <li>
                      <strong>{{ $t("distance") }}:</strong>
                      {{ result.distance.toFixed(4) }}
                    </li>
                    <li>
                      <strong>{{ $t("threshold") }}:</strong>
                      {{ result.threshold }}
                    </li>
                    <li>
                      <strong>{{ $t("similarity metric") }}:</strong>
                      {{ result.similarity_metric }}
                    </li>
                    <li>
                      <strong>{{ $t("detector") }}:</strong>
                      {{ result.detector_backend }}
                    </li>
                    <li>
                      <strong>{{ $t("time") }}:</strong> {{ result.time }}s
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <template v-else>
              <pre v-if="meta.face_analysis" style="font-size: 0.85em">{{
                meta.face_analysis
              }}</pre>
              <span v-else class="has-text-grey">{{
                $t("no analysis available")
              }}</span>
            </template>
          </div>
        </div>
        <div class="column is-4">
          <div class="notification">
            <div class="mb-2">
              <span class="icon"><i class="fa fa-id-card"></i></span>
              <strong>{{ $t("id front analysis") }}</strong>
            </div>
            <template v-if="isJsonAnalysis(meta.id_front_analysis)">
              <div class="box is-shadowless">
                <!-- Campos extraídos -->
                <div v-if="getIdFrontAnalysisObj().fields" class="mb-2">
                  <span class="tag is-primary mb-2">{{
                    $t("extracted fields")
                  }}</span>
                  <table
                    class="table is-bordered is-narrow is-fullwidth is-size-7"
                  >
                    <tbody>
                      <tr
                        v-for="(val, key) in getIdFrontAnalysisObj().fields"
                        :key="key"
                      >
                        <td>
                          <strong>{{ key }}</strong>
                        </td>
                        <td>{{ val }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- Imagen recortada -->
                <div
                  v-if="
                    getIdFrontAnalysisObj().cropped_image &&
                    getIdFrontAnalysisObj().cropped_image.settings
                  "
                  class="mb-2 has-text-centered"
                >
                  <span class="tag is-link mb-2">{{
                    $t("cropped document")
                  }}</span>
                  <figure class="image is-128x128 m-auto py-2">
                    <img
                      :src="`${api_host}/drive/static/${
                        getIdFrontAnalysisObj().cropped_image.settings
                          .final_name
                      }`"
                      alt="Cropped ID"
                      style="border-radius: 8px; border: 1px solid #eee"
                    />
                  </figure>
                </div>
                <!-- Texto crudo -->
                <div
                  v-if="false && getIdFrontAnalysisObj().raw_text"
                  class="mb-2"
                >
                  <span class="tag is-info mb-2">{{ $t("raw text") }}</span>
                  <pre style="font-size: 0.85em; white-space: pre-wrap">{{
                    getIdFrontAnalysisObj().raw_text
                  }}</pre>
                </div>
              </div>
            </template>
            <template v-else>
              <pre v-if="meta.id_front_analysis" style="font-size: 0.85em">{{
                meta.id_front_analysis
              }}</pre>
              <span v-else class="has-text-grey">{{
                $t("no analysis available")
              }}</span>
            </template>
          </div>
        </div>
        <div class="column is-4">
          <div class="notification">
            <div class="mb-2">
              <span class="icon"><i class="fa fa-id-card"></i></span>
              <strong>{{ $t("id back analysis") }}</strong>
            </div>
            <template v-if="isJsonAnalysis(meta.id_back_analysis)">
              <div class="box is-shadowless">
                <!-- Campos extraídos -->
                <div v-if="getIdBackAnalysisObj().fields" class="mb-2">
                  <span class="tag is-link mb-2">{{
                    $t("extracted fields")
                  }}</span>
                  <table
                    class="table is-bordered is-narrow is-fullwidth is-size-7"
                  >
                    <tbody>
                      <tr
                        v-for="(val, key) in getIdBackAnalysisObj().fields"
                        :key="key"
                      >
                        <td>
                          <strong>{{ key }}</strong>
                        </td>
                        <td>{{ val }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- Imagen recortada -->
                <div
                  v-if="
                    getIdBackAnalysisObj().cropped_image &&
                    getIdBackAnalysisObj().cropped_image.settings
                  "
                  class="mb-2 has-text-centered"
                >
                  <span class="tag is-link mb-2">{{
                    $t("cropped document")
                  }}</span>
                  <figure class="image is-128x128 m-auto py-2">
                    <img
                      :src="`${api_host}/drive/static/${
                        getIdBackAnalysisObj().cropped_image.settings.final_name
                      }`"
                      alt="Cropped ID Back"
                      style="border-radius: 8px; border: 1px solid #eee"
                    />
                  </figure>
                </div>
                <!-- Texto crudo -->
                <div
                  v-if="false && getIdBackAnalysisObj().raw_text"
                  class="mb-2"
                >
                  <span class="tag is-info mb-2">{{ $t("raw text") }}</span>
                  <pre style="font-size: 0.85em; white-space: pre-wrap">{{
                    getIdBackAnalysisObj().raw_text
                  }}</pre>
                </div>
              </div>
            </template>
            <template v-else>
              <pre v-if="meta.id_back_analysis" style="font-size: 0.85em">{{
                meta.id_back_analysis
              }}</pre>
              <span v-else class="has-text-grey">{{
                $t("no analysis available")
              }}</span>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="columns mt-4">
      <div class="column is-6">
        <div class="box">
          <div class="has-text-centered mb-3">
            <button
              class="button is-primary is-rounded"
              @click="check_selfie_match"
            >
              <span class="icon">
                <i class="fa fa-bolt"></i>
              </span>
              <span>{{ $t("check selfie match") }}</span>
            </button>
          </div>
          <div v-if="selfie_match_result" class="box is-shadowless">
            <div class="level mb-3">
              <div class="level-left">
                <div class="level-item">
                  <span class="icon is-large">
                    <i
                      class="fa"
                      :class="
                        selfie_match_result.verified
                          ? 'fa-check-circle has-text-success'
                          : 'fa-times-circle has-text-danger'
                      "
                      style="font-size: 2rem"
                    ></i>
                  </span>
                </div>
                <div class="level-item">
                  <h3 class="title is-5 mb-0">
                    {{
                      selfie_match_result.verified
                        ? "Verificación exitosa"
                        : "Verificación fallida"
                    }}
                  </h3>
                </div>
              </div>
              <div class="level-right">
                <span class="tag is-info is-medium">{{
                  selfie_match_result.model
                }}</span>
              </div>
            </div>
            <div>
              <p>
                <strong>{{ $t("distance") }}:</strong>
                {{ selfie_match_result.distance.toFixed(4) }}
              </p>
              <p>
                <strong>{{ $t("threshold") }}:</strong>
                {{ selfie_match_result.threshold }}
              </p>
              <p>
                <strong>{{ $t("similarity metric") }}:</strong>
                {{ selfie_match_result.similarity_metric }}
              </p>
              <p>
                <strong>{{ $t("detector") }}:</strong>
                {{ selfie_match_result.detector_backend }}
              </p>
              <p>
                <strong>{{ $t("time") }}:</strong>
                {{ selfie_match_result.time }}s
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <div class="has-text-centered mb-3">
            <button
              class="button is-primary is-rounded"
              @click="check_document_match"
            >
              <span class="icon">
                <i class="fa fa-bolt"></i>
              </span>
              <span>{{ $t("check document match") }}</span>
            </button>
          </div>
          <div v-if="document_match_result" class="box is-shadowless">
            <div class="level mb-3">
              <div class="level-left">
                <div class="level-item">
                  <span class="icon is-large">
                    <i
                      class="fa"
                      :class="
                        document_match_result.verified
                          ? 'fa-check-circle has-text-success'
                          : 'fa-times-circle has-text-danger'
                      "
                      style="font-size: 2rem"
                    ></i>
                  </span>
                </div>
                <div class="level-item">
                  <h3 class="title is-5 mb-0">
                    {{
                      document_match_result.verified
                        ? "Verificación exitosa"
                        : "Verificación fallida"
                    }}
                  </h3>
                </div>
              </div>
              <div class="level-right">
                <span class="tag is-info is-medium">{{
                  document_match_result.model
                }}</span>
              </div>
            </div>
            <div>
              <p>
                <strong>{{ $t("distance") }}:</strong>
                {{ document_match_result.distance.toFixed(4) }}
              </p>
              <p>
                <strong>{{ $t("threshold") }}:</strong>
                {{ document_match_result.threshold }}
              </p>
              <p>
                <strong>{{ $t("similarity metric") }}:</strong>
                {{ document_match_result.similarity_metric }}
              </p>
              <p>
                <strong>{{ $t("detector") }}:</strong>
                {{ document_match_result.detector_backend }}
              </p>
              <p>
                <strong>{{ $t("time") }}:</strong>
                {{ document_match_result.time }}s
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get, api_host } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "IdentityVerificationDetailModal",
  components: {
    GenericModal,
    VLazyImage,
  },
  props: {},
  data() {
    return {
      meta: {},
      selfie_match_result: null,
      document_match_result: null,
      error: "",
    };
  },
  computed: {
    api_host() {
      return api_host;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/identity/verification", { uuid: uuid })
        .then((response) => {
          v.meta = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.selfie_match_result = null;
      v.document_match_result = null;
      v.error = "";
    },
    check_selfie_match() {
      let v = this;
      // if (!v.meta.face_image || !v.meta.renap_data) {
      //   v.error = v.$t("missing images for match check");
      //   return;
      // }
      v.$root.loader(true);
      v.selfie_match_result = null;
      post("/identity/verification/check-selfie-match", {
        uuid: v.meta.uuid,
      })
        .then((response) => {
          v.selfie_match_result = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    check_document_match() {
      let v = this;
      // if (!v.meta.id_front_image || !v.meta.renap_data) {
      //   v.error = v.$t("missing images for match check");
      //   return;
      // }
      v.$root.loader(true);
      v.document_match_result = null;
      post("/identity/verification/check-document-match", {
        uuid: v.meta.uuid,
      })
        .then((response) => {
          v.document_match_result = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    isJsonAnalysis(val) {
      if (!val) return false;
      if (typeof val === "object") return true;
      try {
        const parsed = JSON.parse(val);
        return typeof parsed === "object";
      } catch (e) {
        return false;
      }
    },
    getFaceAnalysisObj() {
      if (!this.meta.face_analysis) return null;
      if (typeof this.meta.face_analysis === "object")
        return this.meta.face_analysis;
      try {
        return JSON.parse(this.meta.face_analysis);
      } catch (e) {
        return null;
      }
    },
    getIdFrontAnalysisObj() {
      if (!this.meta.id_front_analysis) return null;
      if (typeof this.meta.id_front_analysis === "object")
        return this.meta.id_front_analysis;
      try {
        return JSON.parse(this.meta.id_front_analysis);
      } catch (e) {
        return null;
      }
    },
    getIdBackAnalysisObj() {
      if (!this.meta.id_back_analysis) return null;
      if (typeof this.meta.id_back_analysis === "object")
        return this.meta.id_back_analysis;
      try {
        return JSON.parse(this.meta.id_back_analysis);
      } catch (e) {
        return null;
      }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
